import type { CityConfig } from "../city-template/types";

export const harrisburgConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Harrisburg",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "harrisburg",
  route: "/cities/harrisburg",
  title: "Emergency Passport Harrisburg, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Harrisburg, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cabarrus County and the Charlotte metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Harrisburg, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Harrisburg and Charlotte metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Harrisburg%20North%20Carolina%20suburban%20landscape%20at%20golden%20hour%20with%20modern%20residential%20neighborhoods%2C%20green%20rolling%20hills%20of%20Cabarrus%20County%2C%20tree-lined%20streets%20and%20community%20parks%2C%20warm%20sunset%20light%20over%20the%20Charlotte%20metro%20northeast%20corridor%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20suburban%20growth%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=harrisburg-hero-nc-001&orientation=landscape",
  heroImageAlt: "Harrisburg North Carolina suburban neighborhoods with rolling hills and warm sunset light in Cabarrus County",
  geoPosition: "35.3239;-80.6537",
  geoPlacename: "Harrisburg, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 230 miles from Harrisburg via I-85",
  },
  nearbyCitiesZips: [
    { name: "Harrisburg", zips: "28075" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Mint Hill", zips: "28227" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Cornelius", zips: "28031" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Gastonia", zips: "28052, 28053, 28054, 28056" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cabarrus County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Charlotte Metro Hub", desc: "Serving Harrisburg, Concord, and the northeast Charlotte metro area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Concord, NC", route: "/cities/concord-nc" },
    { name: "Emergency passport help in Kannapolis, NC", route: "/cities/kannapolis" },
    { name: "Urgent passport services in Huntersville, NC", route: "/cities/huntersville" },
    { name: "Same-day passport help in Matthews, NC", route: "/cities/matthews" },
    { name: "Passport courier services in Mooresville, NC", route: "/cities/mooresville" },
    { name: "Passport courier services in Davidson, NC", route: "/cities/davidson" },
    { name: "Passport courier services in Cornelius, NC", route: "/cities/cornelius" },
    { name: "Fast passport renewal in Salisbury, NC", route: "/cities/salisbury" },
    { name: "Expedited passport services in Gastonia, NC", route: "/cities/gastonia" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Harrisburg remotely via secure courier. We do not have a walk-in office in Harrisburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cabarrus County and the northeast Charlotte metro area travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Cabarrus County and the northeast Charlotte metropolitan region",
  serviceAreaIntro: "From the quiet suburban streets of Harrisburg to the bustling corridors of Concord and Charlotte, from the historic neighborhoods of Kannapolis to the Lake Norman communities of Huntersville and Mooresville — Fast Passport Center serves the entire Harrisburg region. We regularly help travelers from Davidson, Cornelius, Matthews, and Salisbury get their passports fast.",
  nearbyCitiesIntro: "We serve all Harrisburg neighborhoods and the surrounding northeast Charlotte area including Concord, Charlotte, Kannapolis, Matthews, Mint Hill, Huntersville, Mooresville, Davidson, Cornelius, Salisbury, and Gastonia. If you are anywhere in Cabarrus County or the northeast Charlotte metropolitan area, we have you covered.",
  howItWorksIntro: "Most Harrisburg travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Harrisburg travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Harrisburg and Cabarrus County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Harrisburg? Here are the most common ones we hear from Cabarrus County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Harrisburg international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda S.",
      location: "Harrisburg, NC",
      rating: 5,
      text: "My passport expired 2 days before a business trip to Toronto. Fast Passport Center had my renewal ready in 40 hours. Never had to leave Cabarrus County. Amazing service.",
      service: "Passport Renewal",
    },
    {
      name: "Chris P.",
      location: "Harrisburg, NC",
      rating: 5,
      text: "Emergency passport for a family emergency overseas. Got it in 36 hours. The team kept me updated every step. I was amazed this could happen without driving to Atlanta.",
      service: "Emergency Passport",
    },
    {
      name: "Nicole B.",
      location: "Harrisburg, NC",
      rating: 5,
      text: "First passport for my 8-year-old before our Disney cruise. Fast Passport Center walked us through every document and had her passport ready in 5 days. Stress-free from start to finish.",
      service: "Child Passport",
    },
    {
      name: "Greg M.",
      location: "Concord, NC",
      rating: 5,
      text: "Lost my passport 3 days before a conference in Berlin. Fast Passport Center had a replacement in my hands in 24 hours. These guys are lifesavers for the Charlotte metro area.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "harrisburg-1",
      name: "Harrisburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4351 School House Rd",
      city: "Harrisburg",
      state: "NC",
      zip: "28075",
      phone: "(704) 455-2966",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Harrisburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Harrisburg facility. Appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisburg-2",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7850 International Dr",
      city: "Concord",
      state: "NC",
      zip: "28027",
      phone: "(704) 788-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Harrisburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Concord and west Cabarrus County residents. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisburg-3",
      name: "Kannapolis Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1461 Dale Earnhardt Blvd",
      city: "Kannapolis",
      state: "NC",
      zip: "28083",
      phone: "(704) 938-2101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Harrisburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kannapolis and north Cabarrus County. Less crowded than Charlotte.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisburg-4",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles southwest of Harrisburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisburg-5",
      name: "Cabarrus County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "77 Union St S",
      city: "Concord",
      state: "NC",
      zip: "28025",
      phone: "(704) 262-5555",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "5 miles west of Harrisburg",
      website: "https://www.cabarruscounty.us/",
      websiteLabel: "Cabarrus County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "harrisburg-6",
      name: "Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11435 E Independence Blvd",
      city: "Matthews",
      state: "NC",
      zip: "28105",
      phone: "(704) 847-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Harrisburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southeast Charlotte and Mecklenburg County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Harrisburg photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cabarrus County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Harrisburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cabarrus County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Harrisburg travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Harrisburg." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Harrisburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Harrisburg before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Harrisburg for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Harrisburg?", a: "Fast Passport Center offers fast passport renewal in Harrisburg in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Harrisburg?", a: "The nearest regional passport agency to Harrisburg is the Atlanta Passport Agency, approximately 230 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Harrisburg without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Harrisburg?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Harrisburg — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cabarrus County residents." },
    { q: "Do you serve the entire Charlotte metro area?", a: "Absolutely. Fast Passport Center serves the entire Charlotte–Concord–Gastonia metropolitan area including Harrisburg, Concord, Charlotte, Kannapolis, Matthews, Mint Hill, Huntersville, Mooresville, Davidson, Cornelius, Salisbury, and Gastonia. Our courier service works seamlessly from any address in the metro area." },
    { q: "Can I expedite a child passport in Harrisburg?", a: "Yes. Fast Passport Center expedites child passports in Harrisburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Cabarrus County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Harrisburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Harrisburg", address: "7520 Plaza Rd, Harrisburg, NC 28075", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Harrisburg", address: "4100 Harrisburg Rd, Harrisburg, NC 28075", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "Walmart Supercenter — Concord", address: "2420 Supercenter Dr NE, Concord, NC 28025", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "CVS Pharmacy — Concord", address: "8525 Pit Stop Ct NW, Concord, NC 28027", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Kannapolis", address: "1910 S Cannon Blvd, Kannapolis, NC 28083", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "CVS Pharmacy — Matthews", address: "1409 Matthews Township Pkwy, Matthews, NC 28105", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Huntersville", address: "16410 Statesville Rd, Huntersville, NC 28078", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Concord",
      address: "2831 Derita Ave, Concord, NC 28027",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte South",
      address: "8520 E Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Kannapolis",
      address: "615 Lakeview St, Kannapolis, NC 28081",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves north Cabarrus County and Kannapolis residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Matthews",
      address: "1510 N Independence Blvd, Matthews, NC 28105",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves southeast Charlotte and Mecklenburg County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "15 miles southwest of Harrisburg",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Primary international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. Only 20 minutes from Harrisburg.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "55 miles northeast of Harrisburg",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for Piedmont Triad travelers. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "130 miles east of Harrisburg",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Cabarrus County Register of Deeds',
      description: 'Marriage licenses and records for Cabarrus County. Apply in person or request certified copies.',
      url: 'https://www.cabarruscounty.us/departments/register-of-deeds',
    },
    {
      label: 'Cabarrus County Clerk of Superior Court',
      description: 'Divorce records and decrees for Cabarrus County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/cabarrus-county/cabarrus-county-clerk-of-superior-court',
    },
  ],
};